import React, { createContext, useContext } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { sessionTools } from '@medely/base';
import { eventNameFromPayload } from './utils';
import { Analytics, IPayload, AnalyticsProviderProps } from './interface';

// @ts-ignore
const AnalyticsContext = createContext<AnalyticsBrowser>(undefined);

export const AnalyticsProvider = ({ children, writeKey }: AnalyticsProviderProps) => {
  const analytics = AnalyticsBrowser.load({ writeKey });
  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};

const fetchSessionIdAndRecordActivity = async () => {
  await sessionTools.recordActivity();
  const sessionId = await sessionTools.getOrUpdateSessionId();
  return sessionId;
};

export const useAnalytics = (): Analytics => {
  const analytics = useContext(AnalyticsContext);

  const identify = async (
    userId: string,
    traits: Record<string, unknown>,
    options?: Record<string, unknown>,
  ) => {
    const sessionId = await fetchSessionIdAndRecordActivity();
    analytics.identify(userId, { ...traits, sessionId }, options);
  };

  function track(payload: IPayload): Promise<void>;
  function track(eventName: string, payload?: Record<string, unknown>): Promise<void>;
  async function track(
    eventNameOrPayload: string | IPayload,
    payload?: Record<string, unknown>,
  ): Promise<void> {
    if (typeof eventNameOrPayload === 'string') {
      const eventName = eventNameOrPayload as string;
      const sessionId = await fetchSessionIdAndRecordActivity();

      analytics.track(eventName, { ...payload, sessionId });
    } else {
      const eventPayload = eventNameOrPayload as IPayload;
      const eventName = eventNameFromPayload(eventPayload);

      const sessionId = await fetchSessionIdAndRecordActivity();
      analytics.track(eventName, { ...eventPayload, sessionId });
    }
  }

  return {
    identify,
    track,
  } as Analytics;
};

export default useAnalytics;
